/**
 * Created by pbo on 21/04/16.
 */
angular.module('taric.duty.calculate.data', ['common.helper', 'taric.model.cd', 'common.model.geoarea',  'common.filter.commoditycode', 'common.filter.description', 'common.filter.specialCharacterToHtml', 'common.filter.decimalNumber','taric.model.monetaryunits', 'common.filter.dutyexpression.description'])
    .controller('CalculateDutyDataCtrl', function ($translatePartialLoader, CalculateDutyModel, MonetaryUnitsModel, GeographicalAreaModel,  $filter, CONSTANTS, CommonHelper, $stateParams, $rootScope) {
        $translatePartialLoader.addPart('taric/duties/calculate');
        var dataCtrl = this;
        dataCtrl.init = function () {
            // Validated data used for calculation input
            dataCtrl.inputData = CalculateDutyModel.getCalculationInput();
            // Backing data model for view
            dataCtrl.model = CalculateDutyModel;

            // Initialize work area or copy from backing data model if we come here from other tabs
            if (dataCtrl.inputData.tradeDirection === 'I') {
                dataCtrl.isImport = true;
            } else {
                dataCtrl.isImport = false;
            }

            // If model hasn't been initialized get selection lists for countries and regions
            if (dataCtrl.model.countriesAndRegions.count === 0) {
                GeographicalAreaModel.getCountriesOfOrigin(dataCtrl.inputData.simulationDate).then(function (result) {
                    dataCtrl.model.countriesAndRegions = result;
                }, function (error) {
                    dataCtrl.errorCode = error.data.code;
                    dataCtrl.errorParams = error.data.params;
                    dataCtrl.errorType = error.data.errorType;
                });
            }

            // If model hasn't been initialized get selection lists for monetary units for customs value and duty
            if (dataCtrl.model.customsValueMonetaryUnits.count === 0) {
                MonetaryUnitsModel.customsValueMonetaryUnits(dataCtrl.inputData.simulationDate).then(function (result) {
                    dataCtrl.model.customsValueMonetaryUnits = result;

                    // Update selected customs value currency
                    if ($stateParams.cu){
                        for (let count = 0; count < dataCtrl.model.customsValueMonetaryUnits.items.length; count++) {
                            if ($stateParams.cu === dataCtrl.model.customsValueMonetaryUnits.items[count].id) {
                                dataCtrl.inputData.customsValueCurrency = $stateParams.cu;
                            }
                        }
                    }
                }, function (error) {
                    dataCtrl.errorCode = error.data.code;
                    dataCtrl.errorParams = error.data.params;
                    dataCtrl.errorType = error.data.errorType;
                });
                MonetaryUnitsModel.dutyMonetaryUnits(dataCtrl.inputData.simulationDate).then(function (result) {
                    dataCtrl.model.dutyMonetaryUnits = result;

                    // Update selected duty currency
                    if ($stateParams.cu){
                        for (let count = 0; count < dataCtrl.model.dutyMonetaryUnits.items.length; count++) {
                            if ($stateParams.cu === dataCtrl.model.dutyMonetaryUnits.items[count].id) {
                                dataCtrl.inputData.dutyCurrency = $stateParams.cu;
                            }
                        }
                    }
                }, function (error) {
                    dataCtrl.errorCode = error.data.code;
                    dataCtrl.errorParams = error.data.params;
                    dataCtrl.errorType = error.data.errorType;
                });
            }

            // Customs value
            if (dataCtrl.inputData.customsValue !== null) {
                dataCtrl.customsValue = CommonHelper.formatDecimalNumber(dataCtrl.inputData.customsValue, 2, '', CONSTANTS.decimalSeparator);
            }
            dataCtrl.customsValueCurrency = dataCtrl.inputData.customsValueCurrency;

            // Net weight
            if (dataCtrl.inputData.netWeight !== null) {
                dataCtrl.netWeight = CommonHelper.formatDecimalNumber(dataCtrl.inputData.netWeight,
                    CommonHelper.getNumberFraction(dataCtrl.inputData.netWeight),
                    '', CONSTANTS.decimalSeparator);
            }

            if (dataCtrl.inputData.supplementaryUnitValue !== null) {
                dataCtrl.supplementaryUnitValue = CommonHelper.formatDecimalNumber(dataCtrl.inputData.supplementaryUnitValue,
                    CommonHelper.getNumberFraction(dataCtrl.inputData.supplementaryUnitValue),
                    '', CONSTANTS.decimalSeparator);
            }

            // Duty currency
            dataCtrl.dutyCurrency = dataCtrl.inputData.dutyCurrency;
            dataCtrl.controlCountry = {};
            dataCtrl.controlCountryOfDispatch = {};
            dataCtrl.controlCountryOfPreferentialOrigin = {};

            dataCtrl.infoCode = CommonHelper.validateSimulationDateAfterOrBefore(dataCtrl.inputData.simulationDate);
            if (dataCtrl.infoCode &&
                "i8n.common.pastDate" === dataCtrl.infoCode) {
                dataCtrl.infoParams = CONSTANTS.pastDate;
            }

            dataCtrl.updateCalculationSupportVersionVisibility();
            dataCtrl.updateCountryOfPreferentialOrigin();
            
        };

        dataCtrl.updateCalculationSupportVersionVisibility = function() {
            dataCtrl.shouldShowCalculationVersion = true;
            const uccApplicableDate = moment(CONSTANTS.uccApplicableDate, CONSTANTS.dateFormat.toUpperCase(), true).toDate();
            if (CommonHelper.compareDatesWithoutTime(dataCtrl.inputData.simulationDate, uccApplicableDate) < 0 || CONSTANTS.supportedCalculationVersions.length <= 1) {
                dataCtrl.shouldShowCalculationVersion = false;
            }
        };

        dataCtrl.updateCountryOfPreferentialOrigin = function() {
            dataCtrl.showCountryOfPreferentialOrigin  = true;
            if (dataCtrl.inputData.tradeDirection === 'E' || dataCtrl.inputData.version === 'PRE_UCC' || dataCtrl.model.quotaOrderNumbersAndRequiredCountryOfDispatch.countryOfDispatchRequired){
                dataCtrl.showCountryOfPreferentialOrigin  = false;
                dataCtrl.inputData.countryOfPreferentialOrigin = null;
            }
        };

        dataCtrl.updateProcedureCode = function() {
            if (dataCtrl.inputData.version === 'PRE_UCC'){
                dataCtrl.inputData.procedureCode = null;
            }
        };

        dataCtrl.onCalculationChange = function() {
			dataCtrl.updateCountryOfPreferentialOrigin();
            dataCtrl.loadPreferenceCodesAndSupplementaryUnit();
            dataCtrl.updateProcedureCode();
        };

        dataCtrl.resetError = function () {
            dataCtrl.errorCode = null;
            dataCtrl.errorParams = null;
            dataCtrl.errorType = null;
        };

        dataCtrl.getFormattedSimulationDate = function () {
            return $filter('date')(dataCtrl.inputData.simulationDate, CONSTANTS.dateFormat);
        };

        dataCtrl.getFormattedCommodityCode = function () {
            return $filter('commodityCode')(dataCtrl.inputData.commodityCode);
        };

        dataCtrl.getCountryOfDispatch = function () {
            for (let idx=0; idx < dataCtrl.model.countriesAndRegions.items.length; idx++) {
                if (dataCtrl.model.countriesAndRegions.items[idx].id === dataCtrl.inputData.countryOfDispatch) {
                    dataCtrl.model.countryOfDispatchObject = dataCtrl.model.countriesAndRegions.items[idx];
                    break;
                }
            }
        };

        dataCtrl.getCountriesAndRegions = function () {
            return dataCtrl.model.countriesAndRegions.items;
        };

        dataCtrl.updateCountry = function (country) {
            dataCtrl.inputData.country = country;
            if (!dataCtrl.model.quotaOrderNumbersAndRequiredCountryOfDispatch.countryOfDispatchRequired){
                dataCtrl.updateCountryOfPreferentialOrigin();
                dataCtrl.loadPreferenceCodesAndSupplementaryUnit();
            }
        };

        dataCtrl.onCountryOfDispatchChange = function (countryOfDispatch) {
            dataCtrl.inputData.countryOfDispatch = countryOfDispatch;
            dataCtrl.loadPreferenceCodesAndSupplementaryUnit();
        };

        dataCtrl.onCountryOfPreferentialOriginChange = function (countryOfPreferentialOrigin) {
            dataCtrl.inputData.countryOfPreferentialOrigin = countryOfPreferentialOrigin;
            dataCtrl.loadPreferenceCodesAndSupplementaryUnit();
        };

        dataCtrl.resetPreferenceCodesAndSupplementaryUnit = function () {
            dataCtrl.inputData.preferenceCode = null;
            dataCtrl.inputData.supplementaryUnit = null;
            dataCtrl.supplementaryUnitValue = null;
            dataCtrl.inputData.supplementaryUnitValue = null;
            dataCtrl.model.preferenceCodesAndSupplementaryUnit = {preferenceCodes: {count: 0, items: []}};
        };

        // Load preference codes from server if country or countryOfPreferentialOrigin has changed
        dataCtrl.loadPreferenceCodesAndSupplementaryUnit = function () {
            dataCtrl.resetError();
            dataCtrl.resetPreferenceCodesAndSupplementaryUnit();
            dataCtrl.resetQuotaOrderNumbers();
            dataCtrl.resetCountryOfDispatch();
            dataCtrl.updateCountryOfPreferentialOrigin();
            if (CommonHelper.removeSpaceCharacters(dataCtrl.inputData.country) === "" && CommonHelper.removeSpaceCharacters(dataCtrl.inputData.countryOfPreferentialOrigin) === "" ){
                return;
            }
            dataCtrl.loadingReferenceData = true;
            CalculateDutyModel.getPreferenceCodesAndSupplementaryUnit(dataCtrl.inputData.commodityCode, dataCtrl.inputData.country, dataCtrl.inputData.simulationDate, dataCtrl.inputData.tradeDirection, dataCtrl.inputData.countryOfPreferentialOrigin, dataCtrl.inputData.version).then(function (result) {
                dataCtrl.model.preferenceCodesAndSupplementaryUnit = result;
                dataCtrl.loadingReferenceData = false;
            }, function (error) {
                dataCtrl.errorCode = error.data.code;
                dataCtrl.errorParams = error.data.params;
                dataCtrl.errorType = error.data.errorType;
                dataCtrl.loadingReferenceData = false;
                return false;
            });
            return true;
        };

        dataCtrl.onPreferenceCodeChange = function () {
            dataCtrl.resetError();
            dataCtrl.loadQuotaOrderNumbersAndRequiredCountryOfDispatch();
        };

        // Load quota order numbers if preference code has changed
        dataCtrl.loadQuotaOrderNumbersAndRequiredCountryOfDispatch = function () {
            dataCtrl.resetQuotaOrderNumbers();
            dataCtrl.resetCountryOfDispatch();
            const  countryOfPreferentialOrigin = CommonHelper.removeSpaceCharacters(dataCtrl.inputData.countryOfPreferentialOrigin);
            const  country = CommonHelper.removeSpaceCharacters(dataCtrl.inputData.country);
            const preferenceCode = CommonHelper.removeSpaceCharacters(dataCtrl.inputData.preferenceCode);
            if ((country !== "" || countryOfPreferentialOrigin !== "") && preferenceCode !== "") {
                CalculateDutyModel.getQuotaOrderNumbersAndRequiredCountryOfDispatch(dataCtrl.inputData.tradeDirection, dataCtrl.inputData.commodityCode,
                    dataCtrl.inputData.country, dataCtrl.inputData.preferenceCode, dataCtrl.inputData.simulationDate, dataCtrl.inputData.countryOfPreferentialOrigin, dataCtrl.inputData.version).then(function (result) {
                    dataCtrl.model.quotaOrderNumbersAndRequiredCountryOfDispatch = result;                   
                    if (dataCtrl.model.quotaOrderNumbersAndRequiredCountryOfDispatch.countryOfDispatchRequired) {
                        dataCtrl.inputData.countryOfDispatch = dataCtrl.inputData.country;
                    }
                    dataCtrl.updateCountryOfPreferentialOrigin();
                }, function (error) {
                    dataCtrl.errorCode = error.data.code;
                    dataCtrl.errorParams = error.data.params;
                    dataCtrl.errorType = error.data.errorType;

                    if (dataCtrl.errorCode === 'i8n.bl.unauthenticated') {
                        $rootScope.$broadcast('tokenInvalid');
                    }

                    return false;
                });
            }
            return true;
        };

        dataCtrl.resetQuotaOrderNumbers = function () {
            dataCtrl.inputData.quotaOrderNumber = null;
            dataCtrl.inputData.useCurrentQuotaStatus = false;
            dataCtrl.model.quotaOrderNumbersAndRequiredCountryOfDispatch.quotaOrderNumbers = [];
        };

        dataCtrl.resetCountryOfDispatch = function () {
            dataCtrl.model.quotaOrderNumbersAndRequiredCountryOfDispatch.countryOfDispatchRequired = false;
            dataCtrl.inputData.countryOfDispatch = null;
        };

        dataCtrl.validateCustomsValue = function () {
            dataCtrl.resetError();
            dataCtrl.inputData.customsValue = null;

            if (dataCtrl.customsValue === null || dataCtrl.customsValue === '' || dataCtrl.customsValue === undefined) {
                dataCtrl.errorCode = 'i8n.qry.cd.faultcode.107';
                return false;
            }

            if (!CommonHelper.isDecimalNumber(dataCtrl.customsValue)) {
                dataCtrl.errorCode = 'i8n.jsfconv.decnum.notnum';
                return false;
            }

            var customsValue = CommonHelper.getDecimalNumber(dataCtrl.customsValue);
            if (customsValue < 0) {
                dataCtrl.errorCode = 'i8n.jsfconv.decnum.notnegative';
                return false;
            }

            // Customs Value: n..16,2
            // Valid pattern = "^\d{0,14}(\,|\.\d{0,2})?$"
            // Because JavaScript Numbers can only handle accurate up to 15 digits, max value is reduced 1 decimal digit
            if (customsValue > 99999999999999.9) {
                dataCtrl.errorCode = 'i8n.jsfconv.decnum.toobig';
                return false;
            }

            // Do not remove trailing decimal zeros for "Customs Value"
            customsValue = CommonHelper.truncateDecimalNumber(customsValue, 2);
            dataCtrl.customsValue = CommonHelper.formatDecimalNumber(customsValue, 2, '', CONSTANTS.decimalSeparator);
            dataCtrl.inputData.customsValue = customsValue;

            return true;
        };

        dataCtrl.validateNetWeight = function () {
            dataCtrl.resetError();
            dataCtrl.inputData.netWeight = null;

            if (dataCtrl.netWeight === null || dataCtrl.netWeight === '' || dataCtrl.netWeight === undefined) {
                dataCtrl.errorCode = 'i8n.qry.cd.faultcode.108';
                return false;
            }

            if (!CommonHelper.isDecimalNumber(dataCtrl.netWeight)) {
                dataCtrl.errorCode = 'i8n.jsfconv.decnum.notnum';
                return false;
            }

            var netWeight = CommonHelper.getDecimalNumber(dataCtrl.netWeight);
            if (netWeight < 0) {
                dataCtrl.errorCode = 'i8n.jsfconv.decnum.notnegative';
                return false;
            }

            // Net Weight: n..16,6
            // Valid pattern = "^\d{0,10}(\,|\.\d{0,6})?$"
            // Because JavaScript Numbers can only handle accurate up to 15 digits, max value is reduced 1 decimal digit
            if (netWeight > 9999999999.99999) {
                dataCtrl.errorCode = 'i8n.jsfconv.decnum.toobig';
                return false;
            }

            netWeight = CommonHelper.truncateDecimalNumber(netWeight, 6);
            dataCtrl.netWeight = CommonHelper.formatDecimalNumber(netWeight, CommonHelper.getNumberFraction(netWeight), '', CONSTANTS.decimalSeparator);
            dataCtrl.inputData.netWeight = netWeight;

            return true;
        };

        dataCtrl.validateSupplementaryUnit = function () {
            dataCtrl.resetError();
            dataCtrl.inputData.supplementaryUnitValue = null;

            if (dataCtrl.supplementaryUnitValue === null || dataCtrl.supplementaryUnitValue === '' || dataCtrl.supplementaryUnitValue === undefined) {
                dataCtrl.errorCode = 'i8n.qry.cd.faultcode.170';
                return false;
            }

            if (!CommonHelper.isDecimalNumber(dataCtrl.supplementaryUnitValue)) {
                dataCtrl.errorCode = 'i8n.jsfconv.decnum.notnum';
                return false;
            }

            var supplementaryUnitValue = CommonHelper.getDecimalNumber(dataCtrl.supplementaryUnitValue);
            if (supplementaryUnitValue < 0) {
                dataCtrl.errorCode = 'i8n.jsfconv.decnum.notnegative';
                return false;
            }

            // Supplementary Unit: n..16,6
            // Valid pattern = "^\d{0,10}(\,|\.\d{0,6})?$"
            // Because JavaScript Numbers can only handle accurate up to 15 digits, max value is reduced 1 decimal digit
            if (supplementaryUnitValue > 9999999999.99999) {
                dataCtrl.errorCode = 'i8n.jsfconv.decnum.toobig';
                return false;
            }

            supplementaryUnitValue = CommonHelper.truncateDecimalNumber(supplementaryUnitValue, 6);
            dataCtrl.supplementaryUnitValue = CommonHelper.formatDecimalNumber(supplementaryUnitValue, CommonHelper.getNumberFraction(supplementaryUnitValue), '', CONSTANTS.decimalSeparator);
            dataCtrl.inputData.supplementaryUnitValue = supplementaryUnitValue;

            return true;
        };

        dataCtrl.next = function () {
            var valid = dataCtrl.validateForm();
            if (valid) {
                dataCtrl.navigatingToNextTab = true;
                if (dataCtrl.inputData.version === 'UCC' && dataCtrl.isImport && dataCtrl.inputData.procedureCode.startsWith("44")) {
                    // call to rest-service to validate procedure code
                    CalculateDutyModel.isAllowedEndUseProcedureCode().then(function (result) {
                        if (result) {
                            dataCtrl.model.goToNextTab('data').then(function(){
                                dataCtrl.navigatingToNextTab = false;
                            }, function (error) {
                                dataCtrl.errorCode = error.data.code;
                                dataCtrl.errorParams = error.data.params;
                                dataCtrl.navigatingToNextTab = false;
                            });
                        } else {
                            dataCtrl.errorCode = "i8n.qry.cd.procedureCode.endUse_notAllowed";
                        }
                        dataCtrl.navigatingToNextTab = false;
                    }, function (error) {
                       dataCtrl.errorCode = error.data.code;
                       dataCtrl.errorParams = error.data.params;
                       dataCtrl.errorType = error.data.errorType;
                       dataCtrl.navigatingToNextTab = false;

                        if (dataCtrl.errorCode === 'i8n.bl.unauthenticated') {
                            $rootScope.$broadcast('tokenInvalid');
                        }
                    });
                } else {
                    dataCtrl.model.goToNextTab('data').then(function(){
                        dataCtrl.navigatingToNextTab = false;
                    }, function (error) {
                        dataCtrl.errorCode = error.data.code;
                        dataCtrl.errorParams = error.data.params;
                        dataCtrl.errorType = error.data.errorType;
                        dataCtrl.navigatingToNextTab = false;

                        if (dataCtrl.errorCode === 'i8n.bl.unauthenticated') {
                            $rootScope.$broadcast('tokenInvalid');
                            // Need to update dropdown
                            dataCtrl.onPreferenceCodeChange();
                        }

                    });
                }
            }
            return valid;
        };

        dataCtrl.validateCountryAndCountryOfPreferentialOrigin = function() {
            let valid = dataCtrl.validateCountry() && dataCtrl.validateCountryOfPreferentialOrigin();
            if (!valid){
                return false;
            }
            if (dataCtrl.inputData.version === 'UCC') {
                if (CommonHelper.removeSpaceCharacters(dataCtrl.inputData.country)  === "" ){
                    if (CommonHelper.removeSpaceCharacters(dataCtrl.inputData.countryOfPreferentialOrigin)  === "") {
                        dataCtrl.errorCode = 'i8n.qry.cd.missing.country_origin_and_or_country_of_preferential_origin';
                        return false;
                    } else if (CommonHelper.removeSpaceCharacters(dataCtrl.inputData.countryOfPreferentialOrigin).length === 4 || dataCtrl.model.preferenceCodesAndSupplementaryUnit.preferenceCodes.count === 0) {
                        dataCtrl.errorCode = "i8n.qry.cd.missing.country_origin";
                        return false;
                    }
                }
            } else if (dataCtrl.inputData.version === 'PRE_UCC') {
                if (CommonHelper.removeSpaceCharacters(dataCtrl.inputData.country)  === "") {
                    dataCtrl.errorCode = 'i8n.qry.cd.faultcode.110';
                    return false;
                }
            }

            return true;
        };

        dataCtrl.validateProcedureCode = function() {
            dataCtrl.resetError();
            if (dataCtrl.inputData.version === 'UCC' && dataCtrl.isImport) {
                if (CommonHelper.removeSpaceCharacters(dataCtrl.inputData.procedureCode) === "") {
                    dataCtrl.errorCode = "i8n.qry.cd.missing.procedure_code";
                    return false;
                }

                if (!dataCtrl.inputData.procedureCode.match(/^([0-9]{2}|[0-9]{4})$/)){
                    dataCtrl.errorCode = "i8n.qry.cd.procedureCode.invalid";
                    return false;
                }
                
            }

            return true;
        };

        dataCtrl.validateForm = function() {
            dataCtrl.resetError();
            var valid = true;

            if (valid && !dataCtrl.validateCustomsValue()) {
                valid = false;
            }
            if (valid && dataCtrl.inputData.customsValueCurrency === null && dataCtrl.model.customsValueMonetaryUnits.count > 1) {
                dataCtrl.errorCode = 'i8n.qry.cd.faultcode.106';
                valid = false;
            }
            if (valid && !dataCtrl.validateNetWeight()) {
                valid = false;
            }
            valid = valid && dataCtrl.validateCountryAndCountryOfPreferentialOrigin() && dataCtrl.validateCountryOfDispatch();
            if (valid && CommonHelper.removeSpaceCharacters(dataCtrl.inputData.preferenceCode) === "" && dataCtrl.isImport) {
                dataCtrl.errorCode = 'i8n.qry.cd.faultcode.171';
                valid = false;
            }

            if (valid && !dataCtrl.validateProcedureCode()) {
                valid = false;
            }
        
            if (valid && dataCtrl.model.preferenceCodesAndSupplementaryUnit.mandatorySupplementaryUnit && !dataCtrl.validateSupplementaryUnit()) {
                valid = false;
            }
            if (valid && CommonHelper.removeSpaceCharacters(dataCtrl.inputData.quotaOrderNumber) === "" && dataCtrl.model.quotaOrderNumbersAndRequiredCountryOfDispatch.quotaOrderNumbers.length > 0) {
                dataCtrl.errorCode = 'i8n.qry.cd.faultcode.105';
                valid = false;
            }
            if (valid && dataCtrl.inputData.dutyCurrency === null && dataCtrl.model.dutyMonetaryUnits.count > 1) {
                dataCtrl.errorCode = 'i8n.qry.cd.faultcode.106';
                valid = false;
            }

            return valid;
        };

        dataCtrl.validateCountry = function(){
            dataCtrl.errorCode = dataCtrl.controlCountry.validate();
            return  dataCtrl.errorCode === null;
        };

        dataCtrl.validateCountryOfPreferentialOrigin = function(){
            if (!dataCtrl.showCountryOfPreferentialOrigin){
                return true;
            }
            dataCtrl.errorCode = dataCtrl.controlCountryOfPreferentialOrigin.validate();
            return  dataCtrl.errorCode === null;
        };

        dataCtrl.validateCountryOfDispatch = function(){
            var valid = true;
            if (dataCtrl.model.countryOfDispatchEnabled) {
                dataCtrl.errorCode = dataCtrl.controlCountryOfDispatch.validate();
                valid = dataCtrl.errorCode === null;
                if(valid && CommonHelper.removeSpaceCharacters(dataCtrl.inputData.countryOfDispatch)  === "")
                    dataCtrl.errorCode = 'i8n.qry.cd.faultcode.110';
                valid = false;
            }
            return valid;
        };

        dataCtrl.handleError = function(error){
            if(!error){
                dataCtrl.errorCode = null;
                dataCtrl.errorParams = null;
            } else {
                dataCtrl.errorCode = error.errorCode;
                dataCtrl.errorParams = error.errorParams;
            }
        };
    });




// WEBPACK FOOTER //
// ./app/taric/duties/calculate/data/cd.data.js